<template>
  <div class="das-dropdown" :class="{ 'dd-placeholder': !editInput }" @click.stop="toggleList()">
    {{ editInput ? editInput : defaultDropdownText[defaultText] }}
    <sup class="red-asterisk" v-if="!editInput">*</sup>
    <span class="caret"></span>
    <ul :class="{ 'display-block': showList, 'display-none': !showList }">
      <li :class="{ 'display-block': showList, 'display-none': !showList }" v-for="(opt, index) in options" :key="`${optionField}-${index}`" @click.stop="selectedData(opt)">
        {{ opt[optionField] }}
      </li>
    </ul>
  </div>
</template>

<script>
import { find } from "lodash";
import { mapGetters } from "vuex";
export default {
  name: "das-dropdown",
  props: {
    options: {
      type: Array,
      default: () => []
    },
    optionField: {
      type: String,
      default: ""
    },
    valueField: {
      type: String,
      default: ""
    },
    defaultText: {
      type: String,
      default: null
    },
    input: {
      type: String,
      default: null
    },
    id: {
      type: String,
      required: false,
      default: null
    }
  },
  data() {
    return {
      defaultDropdownText: {
        trigger: "Select Trigger",
        stepResponse: "Select a Step Response",
        participantInfo: "Select a Field",
        milestone: "Select Milestone(s)",
        language: "Select Language(s)",
        birthDate: "Select an Operator",
        country: "Select a Country",
        gender: "Select Gender",
        actionType: "Select an Action",
        taskDetails: "Select an Activity",
        dob: "Select a Date",
        ageRange: "Select an Age Range",
        stepinActivityResponse: "Select a Step Response"
      },
      showList: false,
      selectedText: null
    };
  },
  methods: {
    toggleList() {
      this.showList = !this.showList;

      this.$root.$emit("close-all-drop-downs", this.id); // this will close only multi dropdown( multi )
    },
    selectedData(data) {
      this.showList = false;
      this.selectedText = data[this.optionField];
      this.$emit("selected-data", data);
    },
    updateSelectedText() {
      this.selectedText = "";
      if (this.input) {
        const selectedObj = find(this.options, [this.valueField, this.input]);

        if (this.defaultText === "ageRange") {
          // When the field is Age Range
          this.selectedText = this.getDynamicSchedulingServiceData.getAgeRangeText(this.input);
        } else if (this.defaultText === "gender") {
          // When the field is Gender
          this.selectedText = this.getDynamicSchedulingServiceData.getGenderText(this.input);
        } else {
          this.selectedText = selectedObj && selectedObj[this.optionField];
        }
      }
    }
  },
  computed: {
    editInput() {
      this.updateSelectedText();
      return this.selectedText;
    },
    ...mapGetters(["getDynamicSchedulingServiceData"])
  },
  mounted() {
    this.$root.$on("close-all-drop-downs", data => {
      if (data == "all" || data !== this.id) {
        this.showList = false;
      }
    });
  }
};
</script>

<style lang="scss" scoped>
.display-block {
  display: block;
}

.disabled-item {
  opacity: 0.5;
  pointer-events: none;
  cursor: not-allowed;
}

.display-none {
  display: none;
}

.dd-placeholder {
  color: #b0bac9 !important;
  font-size: 13px;
  padding: 7px 12px !important;
  font-weight: normal;
}

.das-dropdown {
  border: solid 1px #d3dfe4;
  padding: 6px 17px;
  border-radius: 3px;
  position: relative;
  cursor: pointer;
  margin-bottom: 15px;
  width: 100%;

  .red-asterisk {
    color: #f16559;
    font-size: 14px;
    font-weight: bold;
    top: -0.2em;
  }

  .caret {
    width: 0;
    height: 0;
    border-left: 7px solid transparent;
    border-right: 7px solid transparent;
    border-top: 6px solid #b0bac9;
    top: 14px;
    right: 7px;
    position: absolute;
  }

  ul {
    font-family: RobotoRegular;
    font-size: 15px;
    margin: 0;
    padding: 0;
    list-style: none;
    position: absolute;
    z-index: 9;
    top: 0;
    width: 100%;
    max-height: 250px;
    overflow: auto;
    left: 0;
    //box-shadow: 0 1px 0px 0 rgba(230, 230, 230 , 2%), 0 1px 9px 0 rgba(230, 230, 230 , 100%);
    box-shadow: 0 4px 10px 0 rgba(0, 0, 0, 0.25);
    border-radius: 4px;
    padding: 10px 0;
    background: #ffffff;

    li {
      display: block;
      text-decoration: none;
      color: #000;
      /* border-top: 1px solid #ffffff; */
      padding: 5px 15px 5px 15px;
      background: #ffffff;
      margin-left: 1px;
      white-space: nowrap;

      &:hover {
        background: rgba(0, 0, 0, 0.025);
      }
    }
  }

  ul::-webkit-scrollbar {
    height: 3px;
  }

  ul::-webkit-scrollbar-thumb {
    background-color: #c4c4c4;
    border-radius: 4px;
    height: 3px;
    border: 3px solid transparent;
  }

  ul::-webkit-scrollbar-track {
    background: transparent;
  }

  ul::-webkit-scrollbar {
    width: 4px;
  }
}
</style>
